import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-232ba23e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"7px"} }, null, -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "column justify-between full-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_language_selector = _resolveComponent("language-selector")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_header, {
      elevated: "",
      class: "bg-primary text-white",
      "height-hint": "98"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_q_btn, {
              dense: "",
              flat: "",
              round: "",
              icon: "menu",
              onClick: _ctx.toggleMenu
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_toolbar_title),
            _createVNode(_component_q_space),
            _createVNode(_component_language_selector, {
              lightBorder: "",
              class: "q-ml-lg",
              modelValue: _ctx.language,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.language) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_q_btn, {
              flat: "",
              round: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_avatar, { size: "40px" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      style: {"object-fit":"cover"},
                      src: _ctx.user.avatar,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'account.information' })))
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_drawer, {
      modelValue: _ctx.isMenuOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isMenuOpen) = $event)),
      "show-if-above": "",
      class: "bg-primary",
      "mini-to-overlay": "",
      mini: _ctx.miniState,
      onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.miniState = false)),
      onMouseout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.miniState = true)),
      width: 240,
      "mini-width": "70"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menuItem, index) => {
                return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  key: index,
                  clickable: "",
                  onClick: ($event: any) => (_ctx.$router.push({ name: menuItem.to })),
                  active: _ctx.$route.path.startsWith(`/${menuItem.link}`),
                  class: "menu-item",
                  "active-class": "active-link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, {
                      avatar: "",
                      class: "flex-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          class: "icon",
                          name: menuItem.icon
                        }, null, 8, ["name"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menuItem.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["onClick", "active"])), [
                  [_directive_ripple]
                ])
              }), 128)),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_q_separator, { color: "white" }),
                    _withDirectives(_createVNode(_component_q_item, {
                      clickable: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'user.overview' }))),
                      active: _ctx.$route.path.startsWith('users'),
                      class: "menu-item",
                      "active-class": "active-link"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, {
                          avatar: "",
                          class: "flex-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              class: "icon",
                              name: "group"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Users')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["active"]), [
                      [_directive_ripple]
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_q_item, {
                clickable: "",
                onClick: _ctx.signOut
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, {
                    avatar: "",
                    class: "flex-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        color: "white",
                        name: "logout"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, { style: {"color":"white"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('Logout')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]), [
                [_directive_ripple]
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "mini"])
  ], 64))
}